import styled from 'styled-components';
import { COLOR_WHITE, COLOR_RED, COLOR_BLACK } from '../../../assets/styles/colors';
import { BP_TABLET_MAX, BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';

export default styled.tr`
  background: ${COLOR_WHITE};

  &:last-child {
    td {
      &:first-child {
        ${({ hasPagination }) => (hasPagination ? `` : `border-bottom-left-radius: 12px;`)}
      }
      &:last-child {
        ${({ hasPagination }) => (hasPagination ? `` : `border-bottom-right-radius: 12px;`)}
      }
      &:after {
        display: none;
      }
    }
  }
  td {
    padding: 11px 0px;
    text-align: center;
    position: relative;

    .buy-button {
      padding: 4px 20px 3px 20px;
      font-size: 14px;
      text-transform: uppercase;
      min-width: 110px;
      border-radius: 8px;
    }

    .bid-button {
      padding: 4px 20px 3px 20px;
      font-size: 14px;
      text-transform: uppercase;
      margin-left: 8px;
      min-width: 110px;
      border-radius: 8px;
    }
    .cancel-button {
      padding: 4px 20px 3px 20px;
      font-size: 14px;
      text-transform: uppercase;
      margin-left: 8px;
      min-width: 110px;
      border-radius: 8px;
    }

    &:after {
      content: '';
      position: absolute;
      bottom: 0px;
      height: 1px;
      width: 100%;
      background: rgba(47, 46, 65, 0.1);
      left: 0;
    }
    &:first-child {
      text-align: left;
      padding-left: 32px;

      p {
        float: left;
      }

      &:after {
        width: calc(100% - 32px);
        right: 0px;
        left: auto;
      }
    }
    &:nth-child(5) {
      width: 120px;
      /*   width: 180px; */
    }
    &:last-child {
      padding-right: 32px;
      text-align: right;
      width: 450px;

      /*     width: 180px; */
      &:after {
        width: calc(100% - 32px);
        right: auto;
        left: 0px;
      }
    }
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    display: flex;
    margin-bottom: 16px;
    box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
    border-radius: 12px;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    td {
      padding: 0px 0px;
      &:after {
        display: none;
      }
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      &:first-child {
        padding-top: 24px;
        padding-left: 16px;
        padding-right: 16px;
        width: 100%;
      }
      &:nth-child(2) {
        padding-top: 0px;
        padding-left: 16px;
        padding-right: 16px;
        width: 100%;
      }
      &:nth-child(3) {
        padding-top: 10px;
        padding-left: 16px;
        padding-right: 16px;
        width: 100%;
      }
      &:nth-child(4) {
        padding-top: 4px;
        padding-left: 16px;
        padding-right: 16px;
        width: 100%;
      }
      &:last-child {
        padding-bottom: 24px;
        padding-left: 16px;
        padding-right: 16px;
        width: 100%;
        display: flex;
        flex-direction: column;
        button {
          width: 100%;
          margin-left: 0px;
          margin-top: 8px;
        }
      }
    }
  }
`;

export const AlertSC = styled.span`
  cursor: pointer;
  position: relative;
  width: 16px;
  height: 16px;
  background: ${COLOR_RED};
  color: ${COLOR_WHITE};
  margin-top: 5px;
  margin-left: 8px;
  font-size: 12px;
  font-weight: bold;
  display: inline-block;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  &:before {
    content: '!';
    color: white;
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
  }
  &.black {
    background: ${COLOR_BLACK};
  }
  .tooltip {
    color: ${COLOR_RED};
    font-size: 14px;
    font-weight: 600;
    border-radius: 16px;
    background-color: #ffffff;
    box-shadow: 0 4px 15px 0 rgba(47, 46, 65, 0.15);
    display: flex;
    justify-content: center;
    align-items: center;
    height: 48px;
    width: 232px;
    position: absolute;
    z-index: 99;
    left: 32px;
    top: -15px;
    svg {
      transform: rotateZ(-90deg);
      position: absolute;
      left: -25px;
    }
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    .tooltip {
      width: 200px;
    }
  }
`;
